import { parseGetPopularSymptomsVo } from '@/parsers/search';

import { useGetPopularKeywordsQuery } from './search.gql.impl';

const useGetPopularKeywordsForDiseaseSymptomSearch = () => {
  const { data, isLoading } = useGetPopularKeywordsQuery();

  const { popularSymptomList } = parseGetPopularSymptomsVo(data);

  return {
    popularSymptomList,
    isLoading,
  };
};

export default useGetPopularKeywordsForDiseaseSymptomSearch;
